import React from "react";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { Button, FormGroup } from "@mui/material";
import DateFnsUtils from "@date-io/date-fns";
import {
  GetCCDAData,
  InsertPPLogs,
  MailSendingApi,
  SendMailApi,
} from "../../../../api";
import Checkbox from "@mui/material/Checkbox";
import useMediaQuery from "@mui/material/useMediaQuery";

// Update log
// FB  6192   02/06/2023  DK  Added to send secure emails
// FB  6998   06/22/2023  SK  PP - appointment should be listed in Desc. For secure sand simple message adding line break issue
// FB  8638   04/25/2024  GA  PP : Transmit status is not showing for the Simple email and notify admin email.

export default function SecureMail(props: any) {
  const matches = useMediaQuery("(min-width:600px)");
  const [provider, setProvider] = React.useState("");
  const [FromDate, setFromDate] = React.useState(new Date());
  const [ToDate, setToDate] = React.useState(new Date());
  const [card, setCardOpen] = React.useState(false);
  const [errorCard, setErrorCard] = React.useState(false);
  const [sentcard, setSentcard] = React.useState(false);
  const [value, setValue] = React.useState<any>([]);
  const [CCDAattached, setCCDAattached] = React.useState("");
  const [emailAddress, setEmailAddress] = React.useState("");
  const [subject, setSubject] = React.useState("");
  const [content, setContent] = React.useState("");
  const [isDisabled, setIsDisabled] = React.useState(true);

  const handleRadioChange = (event: any) => {
    const abcsss = new Array(ids);
    const qwerty = abcsss.toString();
    SendEmail();
    setCardOpen(false);
  };

  const [CCDAarray, setCCDAarray] = React.useState<Array<CardProps>>([
    {
      ccdaid: "",
      created_Date: "",
    },
  ]);
  type CardProps = {
    ccdaid: string;
    created_Date: string;
  };

  const handlechange = async () => {
    setIds([]);
    setCCDAattached("");
    const abc = new Date(FromDate);

    const FromDateValue = abc.toLocaleDateString("en-ZA");
    const def = new Date(ToDate);
    const ToDateValue = def.toLocaleDateString("en-ZA");
    var datalocal = sessionStorage.getItem("user");
    if (datalocal != null) {
      const user = JSON.parse(datalocal);
      if (user.Patient_n != null) {
        var data = await GetCCDAData(user.EMRID, FromDateValue, ToDateValue);
        setCCDAarray(data);
        if (data.length != 0) {
          setCardOpen(true);
        } else {
          setErrorCard(true);
        }
      }
    }
  };
  const navigate = useNavigate();
  const handleClose = () => {
    setCardOpen(false);
    setErrorCard(false);
  };
  const handleMailClose = () => {
    setSentcard(false);
    setSentcard(false);
    setEmailAddress("");
    setContent("");
    setSubject("");
    setCCDAattached("");
  };
  const [AttachResponse, setAttachResponse] = React.useState<Array<string>>([]);

  async function SendEmail() {
    const abc = new Date(FromDate);
    const FromDateValue = abc.toLocaleDateString("en-ZA");
    const def = new Date(ToDate);
    const ToDateValue = def.toLocaleDateString("en-ZA");
    var datalocal = sessionStorage.getItem("user");
    if (datalocal != null) {
      const user = JSON.parse(datalocal);
      if (user.Patient_n != null) {
        var data = await SendMailApi(
          ids,
          user.EMRID,
          FromDateValue,
          ToDateValue
        );
      }
    }
    setAttachResponse(data);
  }

  const FinalEmail = () => {
    SendFinalEmail();
  };

  //   const Test = () => {
  //     TestPopup();
  //   };
  //   async function TestPopup() {
  //     setSentcard(true);
  //   }
  const JSAlert = require("js-alert");
  const [EmailResponse, setEmailResponse] = React.useState<Array<string>>([]);
  async function SendFinalEmail() {
    const reEmail =
      /^([a-zA-Z0-9_\-\.]+)(?!.*[_./#&+!$%*=?'`{|^_-]{2})([ A-Za-z0-9_./#&+!$%*=?'`{|^_-]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;

    if (reEmail.test(emailAddress) == false) {
      JSAlert.alert("Please Enter Valid Email", null, JSAlert.Icons.Failed);
    } else if (content == "") {
      JSAlert.alert("Please Enter Message", null, JSAlert.Icons.Failed);
    } else if (subject == "") {
      JSAlert.alert("Please Enter Subject", null, JSAlert.Icons.Failed);
    }
    // (regex.test(emailAddress) == true && content != "" && subject != "")
    else {
      //FB 6998 - Start
      let updatedContent=content.replace(/\n\r?/g, "<br/>");     
      var data = await MailSendingApi(
        AttachResponse,
        emailAddress,
        subject,
        updatedContent
      );
      //FB 6998 - End
      setEmailResponse(data);
      setSentcard(true);
      InsertPPLogs(
        "Clicked on Send - Secure Mail",
        window.location.href,
        userName,
        emailAddress,
        data ? "Sent successfully" : "Failed to send" //FB 8638
      );
    }
  }

  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });

  const [ids, setIds] = React.useState<Array<string>>([]);
  const handleCheckboxChange = (event: any) => {
    const selectedId = event.target.value;
    if (ids.includes(selectedId)) {
      const newIds = ids.filter((id: any) => id !== selectedId);
      setIds(newIds);
      console.log(newIds);
      setCCDAattached(newIds.toString());
      if (newIds.length == 0) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }
    } else {
      const newIds = [...ids];
      newIds.push(selectedId);
      setIds(newIds);
      console.log(newIds);
      setCCDAattached(newIds.toString());
      if (newIds.length == 0) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }
    }
  };
  const handleTochange = (e: any) => {
    setEmailAddress(e.target.value);
  };
  const handleSubjectchange = (e: any) => {
    setSubject(e.target.value);
  };
  const handleContentchange = (e: any) => {
    setContent(e.target.value);
  };

  async function InsertLogs() {
    InsertPPLogs("Viewing Secure Mail", window.location.href, userName, "");
  }

  React.useEffect(() => {
    InsertLogs();
  }, []);
  return (
    <div>
      <div
        className="row"
        style={{
          marginTop: matches == false ? "" : "90px",
          marginBottom: "30px",
        }}
      >
        <div className="col-sm-12">
          <div className="card" style={stylestop.container}>
            <div className="card-body">
              <p className="card-title" style={{ textAlign: "left" }}>
                <strong>Secure E-Mail</strong>
              </p>
              <hr></hr>
              <p className="card-text" style={{ textAlign: "left" }}>
                <strong>To : </strong>
                <input
                  id="standard-basic"
                  value={emailAddress}
                  onChange={handleTochange}
                  style={{
                    borderColor: "transparent",
                    border: "none",
                    outline: "none",
                    wordWrap: "break-word",
                    width: "90%",
                  }}
                  type="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                ></input>{" "}
              </p>
              <hr></hr>
              <p className="card-text" style={{ textAlign: "left" }}>
                <strong>Subject : </strong>{" "}
                <input
                  id="standard-basic"
                  value={subject}
                  onChange={handleSubjectchange}
                  style={{
                    width: "95%",
                    borderColor: "transparent",
                    border: "none",
                    outline: "none",
                  }}
                ></input>{" "}
              </p>
              <hr></hr>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    InputLabelProps={{ shrink: true }}
                    format="MM/dd/yyyy"
                    label="From"
                    style={keybaord.container}
                    value={FromDate}
                    onChange={(newValue: any) => {
                      setFromDate(newValue);
                    }}
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
              &nbsp;&nbsp;&nbsp;
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    InputLabelProps={{ shrink: true }}
                    format="MM/dd/yyyy"
                    label="To"
                    value={ToDate}
                    onChange={(newValue: any) => {
                      setToDate(newValue);
                    }}
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
              &nbsp;&nbsp;&nbsp;&nbsp;
              {/* <Button
                style={{
                  backgroundColor: "#13607C",
                  color: "white",
                  marginTop: "25px",
                }}
                onClick={handlechange}
              >
                Get CCDA Files
              </Button> */}
              <button
                className="btn"
                style={{
                  backgroundColor: "#13607C",
                  color: "white",
                  marginTop: "25px",
                }}
                onClick={handlechange}
              >
                Get CCDA Files
              </button>
              <Dialog open={card} onClose={handleClose}>
                <DialogContent style={{ width: "500px", height: "300px" }}>
                  <hr></hr>
                  <h5>Choose CCDA Files</h5>
                  <FormGroup>
                    {CCDAarray.map((x) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            value={x.created_Date}
                            onChange={handleCheckboxChange}
                            id={x.ccdaid}
                          />
                        }
                        label={x.created_Date}
                      />
                    ))}
                  </FormGroup>
                  <br></br>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: isDisabled ? "grey" : "#13607C",
                      color: "white",
                    }}
                    onClick={handleRadioChange}
                    disabled={isDisabled}
                  >
                    Attach
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#13607C",
                      color: "white",
                    }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                </DialogContent>
                <DialogActions></DialogActions>
              </Dialog>
              <hr></hr>
              <p className="card-text" style={{ textAlign: "left" }}>
                <strong>Message: </strong>{" "}
              </p>
              <TextareaAutosize
                aria-label="minimum height"
                minRows={8}
                style={{
                  width: "calc(100% - 5px)",
                  height: "200px",
                }}
                value={content}
                onChange={handleContentchange}
              />
              <br></br>
              <label>
                <strong>Attached Files:</strong>&nbsp;
                <h6>{CCDAattached}</h6>
              </label>
              <br></br>
              <br></br>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#13607C",
                  color: "white",
                }}
                onClick={FinalEmail}
              >
                Send
              </Button>{" "}
              {""}
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#13607C",
                  color: "white",
                }}
                onClick={() => navigate("/user/home/dashboard")}
              >
                Cancel
              </Button>
              <Dialog open={sentcard} onClose={handleClose}>
                <DialogContent style={{ width: "400px", height: "150px" }}>
                  <h5 style={{ textAlign: "center" }}>
                    Mail Sent Successfully
                  </h5>
                  <br></br>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#13607C",
                      color: "white",
                      marginLeft: "140px",
                    }}
                    onClick={handleMailClose}
                  >
                    Ok
                  </Button>
                </DialogContent>
              </Dialog>
              <Dialog open={errorCard} onClose={handleClose}>
                <DialogContent style={{ width: "400px", height: "150px" }}>
                  <h5 style={{ textAlign: "center" }}>No CCDA Data Found</h5>
                  <br></br>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#13607C",
                      color: "white",
                      marginLeft: "140px",
                    }}
                    onClick={handleClose}
                  >
                    Ok
                  </Button>
                </DialogContent>
              </Dialog>
              {/* <div className="form-group">
                <input
                  type="file"
                  className="form-control-file"
                  id="exampleFormControlFile1"
                ></input>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const button = {
  container: {
    backgroundColor: "#13607C",
    color: "white",
  },
};
const stylestart = {
  container: {
    border: "1px grey",
    margin: "20px",
  },
};
const stylestop = {
  container: {
    height: "auto",
    border: "1px grey",
  },
};
const keybaord = {
  container: {
    fontSize: "10px",
  },
};
